import React, { useContext } from 'react';
import c from 'classnames';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import CommentCoreBadgeList from '../../../coreBadge/CoreBadgeList/presets/CommentCoreBadgeList';
import { CommentContext } from '../../CommentContext';
import FooterRowLayout from '../../layouts/FooterRowLayout';
import { useButtonConditionals } from './useButtonConditionals';
import LikeButton from '../LikeButton';
import AwardBadgeButton from '../AwardBadgeButton';
import ReplyButton from '../ReplyButton';
import s from './CommentFooter.scss';
/** All of our comment interaction buttons in a nice row. Includes liking, replying, badge awarding, and editing. */
var CommentFooter = function (_a) {
    var _b = _a.canPostComment, canPostComment = _b === void 0 ? true : _b, className = _a.className;
    var isNewReplyButtonFlagEnabled = useFlag('new_reply_button_global');
    var _c = useContext(CommentContext), comment = _c.comment, isCommentVisible = _c.isCommentVisible;
    var _d = useButtonConditionals({ canPostComment: canPostComment }), showReplyButton = _d.showReplyButton, showAwardBadgeButton = _d.showAwardBadgeButton, showLikeButton = _d.showLikeButton;
    if (!isCommentVisible) {
        return null;
    }
    return (React.createElement(FooterRowLayout, { className: className, blocks: [
            showReplyButton && (React.createElement(ReplyButton, { key: "reply-button", className: c(s['action'], !isNewReplyButtonFlagEnabled && s['action-styled']) })),
            showLikeButton && (React.createElement(LikeButton, { key: "like-button", className: c(s['action'], s['action-styled']) })),
            showAwardBadgeButton && (React.createElement(AwardBadgeButton, { key: "award-badge-button", className: c(s['action'], s['action-styled']) })),
            React.createElement(CommentCoreBadgeList, { comment: comment, key: "badges" }),
        ] }));
};
CommentFooter.displayName = 'CommentFooter';
export default CommentFooter;
//# sourceMappingURL=CommentFooter.js.map